<template>
  <v-dialog v-model="isOpen" width="428">
    <component
      :is="component"
      @close="handleClose"
      v-bind="{ ...props }"
    ></component>
  </v-dialog>
</template>

<script>
import { inject } from '@vue/composition-api';

export default {
  name: 'BaseModal',
  setup() {
    const modalComposition = inject('modalComposition');

    return {
      ...modalComposition
    };
  }
};
</script>
